// import { objectToFormData } from 'utils/object-to-formdata'
import { ApiProvider /*MapServerProvider*/ } from 'providers/request'
import { objectToFormData } from 'utils/object-to-formdata'
import {
  FETCH_PROJECT_BY_ID,
  CREATE_AREA,
  FETCH_AREAS,
  DELETE_AREA_AND_REFETCH,
  TAKE_AREA,
  DELETE_AREA,
  CREATE_TEMP_MOBILITY_PROJECT,
  CREATE_TEMP_HISTORICAL_PROJECT,
} from '../types'

// PROJECT ACTIONS

// Get

export const fetchProjectById = (id) => async (dispatch) => {
  try {
    const res = await ApiProvider.get(`/projects/${id}`)

    dispatch({
      type: FETCH_PROJECT_BY_ID,
      payload: res,
    })
  } catch (err) {
    console.error(err)
  }
}

// AREAS ACTIONS

// Create

export const createArea = (projectId, params) => async (dispatch) => {
  const { file, ...data } = params

  try {
    const formData = objectToFormData({ file, data: JSON.stringify(data) })
    const res = await ApiProvider.post(`/projects/${projectId}/areas`, formData)

    dispatch({
      type: CREATE_AREA,
      payload: res,
    })
  } catch (err) {
    console.error(err)
  }
}

// Get

export const fetchAreas = (projectId) => async (dispatch) => {
  try {
    const res = await ApiProvider.get(`/projects/${projectId}/areas`)

    dispatch({
      type: FETCH_AREAS,
      payload: res,
    })
  } catch (err) {
    console.error(err)
  }
}

export const takeArea = (currentArea) => (dispatch) => {
  dispatch({
    type: TAKE_AREA,
    payload: currentArea,
  })
}

// Delete

export const deleteAreaAndRefetch = (projectId, areaId) => async (dispatch) => {
  try {
    await ApiProvider.delete(`/projects/${projectId}/areas/${areaId}`)
    const res = await ApiProvider.get(`/projects/${projectId}/areas`)

    dispatch({
      type: DELETE_AREA_AND_REFETCH,
      payload: res,
    })
  } catch (err) {
    console.error(err)
  }
}

export const deleteArea = (dispatch) => {
  dispatch({
    type: DELETE_AREA,
    payload: null,
  })
}

export const createTempMobilityProject = (projectId, startDate, endDate) => async (dispatch) => {
  try {
    const res = await ApiProvider.post(`/project/mobility/${projectId}/${startDate}/${endDate}`)

    dispatch({
      type: CREATE_TEMP_MOBILITY_PROJECT,
      payload: res,
    })
  } catch (err) {
    console.error(err)
  }
}

export const createTempHistoricalProject = (projectId) => async (dispatch) => {
  try {
    const res = await ApiProvider.post(`/project/mobility/${projectId}/historical`)

    dispatch({
      type: CREATE_TEMP_HISTORICAL_PROJECT,
      payload: res,
    })
  } catch (err) {
    console.error(err)
  }
}
